import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
import { LocationBlock } from '../../components/LocationBlock';
export function NorthvilleScheduleLocation() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-2635">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2636">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-2637">
          <div data-id="element-2638">
            <h2 className="text-4xl text-ink mb-8" data-id="element-2639">Class Times</h2>
            <ScheduleTable data-id="element-2640" />
          </div>
          <div data-id="element-2641">
            <h2 className="text-4xl text-ink mb-8" data-id="element-2642">Location Details</h2>
            <LocationBlock data-id="element-2643" />
          </div>
        </div>
      </div>
    </section>;
}